import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import Marker from '../Marker/marker';
import { ENV, MAIN_ENV } from 'constants/global.constants';

const MapHabi = ({ centerMap, getAddressPin, reference }) => {
  const lat = centerMap.lat;
  const lng = centerMap.lng;
  const [zoom, setZoom] = useState(16);
  const [center, setCenter] = useState({ lat, lng });

  const gmapskey = { key: ENV[MAIN_ENV.COUNTRY].REACT_APP_GOOGLE_MAPS_KEY };

  const createMapOptions = maps => {
    return {
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      gestureHandling: 'cooperative'
    };
  };

  const onChangeMap = ({ center, zoom }) => {
    setCenter(center);
    setZoom(zoom);
  };

  return (
    <div className="mapaHabi" ref={reference} tabIndex={-1}>
      <GoogleMapReact
        bootstrapURLKeys={gmapskey}
        center={center}
        zoom={zoom}
        onChange={onChangeMap}
        options={createMapOptions}
      >
        <Marker lat={lat} lng={lng} name="Ubicación aproximada" color="#7C01FF" />
      </GoogleMapReact>
    </div>
  );
};
export default MapHabi;
